const ambiente = process.env.NODE_ENV;

console.log('AMBIENTE:', ambiente);

const firebaseConfig =
  ambiente === 'development'
    ? {
        apiKey: 'AIzaSyBcqfIoJe5RTdIAKBxTQx3Z0AiMI7NtekM',
        authDomain: 'campeonato-minas.firebaseapp.com',
        databaseURL: 'https://campeonato-minas.firebaseio.com',
        projectId: 'campeonato-minas',
        storageBucket: "campeonato-minas.appspot.com",
        messagingSenderId: '567475703792',
        appId: '1:567475703792:web:498d1e0249c5185b',
        measurementId: "G-G3FR9PBBMY"
      }
    : {
        apiKey: 'AIzaSyD5jdps_VV7g9gYc4SESuHpCJyfpfnssGM',
        authDomain: 'campeonatos-minas.firebaseapp.com',
        databaseURL: 'https://campeonatos-minas.firebaseio.com',
        projectId: 'campeonatos-minas',
        storageBucket: '',
        messagingSenderId: '1001464962792',
        appId: '1:1001464962792:web:ded01649d5939f55',
        measurementId: "G-XG4FBZ80WJ"
      };

console.log('APLICAÇÃO UTLIZADA:', `${firebaseConfig.projectId}`.toUpperCase());

export default firebaseConfig;
